import { useTranslation } from 'react-i18next';
import {
  StyledIcon, SuccessButtons, SuccessContainer, SuccessContent, SuccessGrid, SuccessHeadline, SuccessMessage,
} from './styles';
import { BottomTriangle } from '../styles';
import { navigate } from 'gatsby';
import type { IDemoSuccess } from '../types';
import { useModal } from '@klv/context/modal';


const DemoSuccess = ({ colorVariant, templateName, backgroundColor = 'dark' }: IDemoSuccess) => {
  const { t } = useTranslation();
  const modalStore = useModal();

  const buttonAction = (url: string) => {
    navigate(url);
    modalStore.close();
  };

  const headline = t('organisms_forms_demo_success_headline');
  const message = t('organisms_forms_demo_success_headline');

  return (
    <SuccessGrid>
      <SuccessContent>
        <SuccessContainer>
          <StyledIcon $backgroundColor={backgroundColor} iconName="BugMarkFilled" color="currentColor" />
          <SuccessHeadline colorVariant={colorVariant} forwardedAs="h2" variant="display3">{headline}</SuccessHeadline>
          <SuccessMessage colorVariant={colorVariant} variant="paragraph2">{message}</SuccessMessage>
          {
            templateName === 'Default' && (
              <SuccessButtons
                variants={['primary', 'ghost']}
                buttonColor="light"
                buttons={[
                  { text: t('organisms_forms_demo_success_buttonOne') || '', action: () => {buttonAction('/features');} },
                  { text: t('organisms_forms_demo_success_buttonTwo') || '', action: () => {buttonAction('/marketing-resources');} },
                ]} />
            )}
        </SuccessContainer>
      </SuccessContent>
      <BottomTriangle />
    </SuccessGrid>
  );
};

export default DemoSuccess;
